import { GetStaticPaths } from 'next'

import { makeGatePage } from '../../components/app-gate/gatePage'
import { gateStaticProps } from '../../components/app-gate/gateStaticProps'

// A rota do app chama-se /cartel (legado), mas a feature chama-se "Minhas
// Lutas" — nunca "Cartel" na copy (identidade verbal do handoff).
export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [{ params: { slug: [] } }],
  fallback: 'blocking',
})

export const getStaticProps = gateStaticProps

export default makeGatePage({ gateKey: 'myFights', ticks: 3 })
